// import badjsReport from 'badjs-report'

// badjsReport.init({
//   id: 1,                                // 上报 id, 不指定 id 将不上报
//   uin: 123,                             // 指定用户 id, (默认已经读取 qq uin)
//   delay: 1000,                          // 当 combo 为 true 可用，延迟多少毫秒，合并缓冲区中的上报（默认）
//   url: 'http://192.168.1.211/badjs',         // 指定上报地址
//   repeat: 5,                            // 重复上报次数(对于同一个错误超过多少次不上报)，避免出现单个用户同一错误上报过多的情况
//   onReport: function (id, errObj) {
//     console.log(id, errObj)
//   },     // 当上报的时候回调。 id: 上报的 id, errObj: 错误的对象
//   offlineLog: true,                    // 是否启离线日志 [默认 false]
//   offlineLogExp: 5,                   // 离线有效时间，默认最近5天
//   level: 4
// })

// badjsReport.tryJs().spyAll()

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import * as filters from './utils/filters'
import store from './store' // 引入vuex store

import VueRouter from 'vue-router'

Vue.use(VueRouter)

// register global utility filters.
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

import 'font-awesome/scss/font-awesome.scss'

import iView from 'iview'
import 'iview/dist/styles/iview.css' // 使用 CSS
import './stylesheets/utilities.scss'
import './stylesheets/color.scss'
import './stylesheets/iview.scss'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import formCreate from '@form-create/iview'
Vue.use(VXETable)
Vue.use(iView)
Vue.use(formCreate)

// import '../static/localStorageDB/localStorageDB'

import getMixin from './option'
import mixin from './scripts/mixin'
import HTTP from './scripts/http'
import _ from 'lodash'
import moment from 'moment'
import hasPermi from './utils/directives/hasPermi'
import drag from './utils/directives/drag'
import localforage from 'localforage'
import { getUserData, getUserDataForPage, setUserData, setUserDataForPage } from './utils/db'

// 斌彬添加全局请求api
import { doGetGeneral, doPostWithURLSearchParams, doPostWithObjectParams, doPostByTextPlain } from '../src/utils/request-common.js'

global.doGetGeneral = doGetGeneral
global.doPostWithURLSearchParams = doPostWithURLSearchParams
global.doPostWithObjectParams = doPostWithObjectParams
global.doPostByTextPlain = doPostByTextPlain

getMixin()
import 'babel-polyfill'
import 'easemob-websdk/dist/strophe-1.2.8'
import '../src/webim.config'
Vue.config.debug = true // 开启错误提示

// Vue.config.errorHandler = (err, vm, info) => {
//   // handle error
//   // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
//   // 只在 2.2.0+ 可用
//   badjsReport.report({
//     err,
//     vm,
//     info,
//     msg: `error:${err} vm:${vm} info:${info}`,
//     type: 'vue.js'
//   })
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, // 挂载vuex
  template: '<App/>',
  render: h => h(App)
})

localforage.config({
  driver: localforage.INDEXEDDB,
  name: 'cloud_his',
  storeName: 'db'
})

Vue.directive('hasPermi', hasPermi)
Vue.directive('hasDrag', drag)
Vue.mixin(mixin)
Vue.prototype.$http = new HTTP()
Vue.prototype.$moment = moment
Vue.prototype.$lodash = _
Vue.prototype.$_ = _
Vue.prototype.$XModal = VXETable.modal
Vue.prototype.getUserData = getUserData
Vue.prototype.getUserDataForPage = getUserDataForPage
Vue.prototype.setUserData = setUserData
Vue.prototype.setUserDataForPage = setUserDataForPage
